import React from "react";

type CircleIconProps = {
    className?: string;
};

export const CircleIcon: React.FC<CircleIconProps> = ({className}) => {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M13 15C11.8954 15 11 14.1046 11 13C11 11.8954 11.8954 11 13 11C14.1046 11 15 11.8954 15 13C15 14.1046 14.1046 15 13 15Z" fill="#FFF600"/>
            <path d="M14.0784 3.05862C13.4667 2.99195 12.851 2.98215 12.2372 3.02921C6.7665 3.44687 2.60954 8.29208 3.02915 13.7628C3.44681 19.2335 8.29203 23.3905 13.7628 22.9709C19.2335 22.5532 23.3904 17.708 22.9708 12.2373C22.9669 12.1765 22.961 12.1157 22.9551 12.0549" stroke="#FFF600" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round"/>
        </svg>
    )
}